import { j as o } from "./index-DHMGk9p5.js";
import { d as c, a as f } from "./index-DHMGk9p5.js";
import { useEffect as m } from "react";
import { I as a } from "./index-B5wsF6Ch.js";
function d(e) {
  return m(() => {
    Object.entries({
      ...e.overrideTheme
    }).forEach(([t, r]) => {
      document.documentElement.style.setProperty(t, r);
    });
  }, [e.overrideTheme]), /* @__PURE__ */ o.jsx("div", { id: "__themer", children: e.children });
}
export {
  c as ClipboardButton,
  f as InputWithCopyButton,
  a as ItemList,
  d as Themer
};
//# sourceMappingURL=shared.js.map
